import React from 'react';
import { observer } from 'mobx-react-lite';
import { Form, InputNumber, Slider } from 'antd';
import QuickTurnBoltStore from 'stores/QuickTurnBoltStore';
import MinAndMaxDimensions from '../MinAndMaxDimensions';

const ShaftLength = () => {
    const { threading, shaft_length, thread_length, threadSizes, thread } = QuickTurnBoltStore;

    function handleChangeShaftLength(value: number): void {
        QuickTurnBoltStore.updateBoltById(QuickTurnBoltStore.boltToken, { shaft_length: value });
    }

    const min = () => {
        return Number((0.5).toFixed(3));
    };

    const max = () => {
        const selectedThread = threadSizes?.find(x => x.id == thread);

        let max = 3;

        if (selectedThread) {
            const ratio = selectedThread?.major_diameter_inch * 10;
            max = ratio <= 3 ? ratio : 3;
        }

        return Number(max.toFixed(3));
    };

    function onChange(value: number) {
        if (value >= min() && value <= max()) {
            QuickTurnBoltStore.setShaftLength(value);

            if (threading === 'Fully Threaded' || (threading === 'Partially Threaded' && value < thread_length + 0.1)) {
                QuickTurnBoltStore.setThreadLength(value - 0.1);
            }
        }
    }

    return (
        <Form.Item label="Length (in.)" className="mb-0">
            <div className="d-flex flex-row align-items-center" style={{ columnGap: '20px' }}>
                <div className="d-flex flex-column flex-grow-1">
                    <Slider
                        className="w-100 m-0 my-2"
                        min={min()}
                        max={max()}
                        step={0.001}
                        tooltip={{
                            formatter: (value?: number) => `${value?.toFixed(3)}`,
                        }}
                        onChange={(value: number) => {
                            onChange(value);
                        }}
                        onAfterChange={(value: number) => {
                            onChange(value);
                            handleChangeShaftLength(value);
                        }}
                        value={shaft_length}
                    />
                    <MinAndMaxDimensions min={min()} max={max()} unit="inch" />
                </div>
                <InputNumber
                    min={min()}
                    max={max()}
                    value={shaft_length}
                    precision={3}
                    step={0.001}
                    onChange={value => {
                        if (value) {
                            onChange(value);
                            handleChangeShaftLength(value);
                        }
                    }}
                    style={{ width: '100px' }}
                    className="LoNotSensitive"
                />
            </div>
        </Form.Item>
    );
};

export default observer(ShaftLength);
